import loginRequester from '../../clients/login/requester';

interface State {
  username: string;
  password: string;
  message: string;
};

export default class {
  declare state: State;

  onCreate() {
    this.state = {
      username: '',
      password: '',
      message: '',
    };
  }
  
  onChange(name: keyof State, { value }: { value: string }) {
    this.state[name] = value;
  }
  
  onSubmit(e: Event) {
    if (e?.preventDefault) e.preventDefault();
    this.state.message = '...';

    loginRequester(this.state.username, this.state.password)
      .then(() => {
        this.state.message = 'Login successful, redirecting...';
        window.location.href = '/';
      })
      .catch((error: Error) => {
        this.state.message = error.message;
      });
  }
};
